var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"answerPage"},[_c('zdy-nav',{attrs:{"leftTitle":_vm.title},on:{"back":_vm.back}}),_c('div',{staticClass:"content"},[_c('div',{staticClass:"Qtext"},[_c('div',{staticClass:"text"},[_vm._v(_vm._s(_vm.questionName))])]),_c('div',{staticClass:"Atext"},[_c('div',{staticClass:"text",domProps:{"innerHTML":_vm._s(_vm.answer)}})])])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }